export const user = () => {
  if (typeof window !== 'undefined') {
    const user = localStorage.getItem('user');

    if (!user) {
      return null;
    }
    let userData = JSON.parse(user);
    return userData?.service_area_id ? userData?.service_area_id : null;
  }
}


